
export default function Imprint() {
    return (
        <div className="flex flex-col items-center p-10 gap-2 text-bold">
        <h1 className="py-4 text-6xl">Impressum</h1>
        <p className="text-2xl">Marianne und Richard Witzko</p>
        <p className="text-2xl">Salzburg</p>
        <p className="text-2xl">Austria</p>
        </div>
    )}